import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import {
  techniciansList,
  allTechnicians,
  regionList,
  specializationList,
} from "constants/technicians";

export const getTechniciansList = async (
  dispatch,
  { pageNum, filters = null, searchString = "" } = {},
) => {
  try {
    const res = await api.technician_list(pageNum, filters, searchString);

    dispatch({ type: techniciansList, payload: res.data });
  } catch (error) {
    dispatch({
      type: techniciansList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getAllTechnicians = async (
  dispatch,
  { pageNum, filters = null, searchString = "" } = {},
) => {
  try {
    const res = await api.technician_list(pageNum, filters, searchString);

    dispatch({ type: allTechnicians, payload: res.data });
  } catch (error) {
    dispatch({
      type: allTechnicians,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

// add technician
export const addTechnician = async (bodyData) => {
  try {
    const res = await api.add_technician(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
//get technician detail by id
export const getTechnicianById = async (id) => {
  try {
    const res = await api.get_technician_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit technician
export const editTechnician = async (id, bodyData) => {
  try {
    const res = await api.edit_technician(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//change technician password
export const changeTechnicianPassword = async (id, bodyData) => {
  try {
    const res = await api.change_password_technician(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get region list
export const getRegionList = async (dispatch) => {
  try {
    const res = await api.region_list();
    dispatch({ type: regionList, payload: res.data });
  } catch (error) {
    dispatch({ type: regionList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

//get specialization list
export const getSpecializationList = async (dispatch) => {
  try {
    const res = await api.specialization_list();
    dispatch({ type: specializationList, payload: res.data });
  } catch (error) {
    dispatch({
      type: specializationList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

//assign technician
export const assignTechnician = async (jobID, bodyData) => {
  try {
    const res = await api.assign_technician(jobID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}
